import './Hours.css'

import ToggleSectionButton from 'components/ToggleSectionButton'
import PropTypes from 'prop-types'
import React from 'react'
import { noop } from 'utils'

import { formatHour } from './utils'

function Hours({ fromHour, isCollapsed, onClick }) {
  const hoursCount = isCollapsed ? 24 - fromHour : 24

  return (
    <div className="hours">
      {Array.from({ length: hoursCount }, (_, index) => (
        <div className="hours-hour-wrapper" key={index}>
          {!isCollapsed && fromHour === index ? (
            <ToggleSectionButton isCollapsed={isCollapsed} onClick={onClick} />
          ) : (
            <div className="hours-icon-placeholder" />
          )}
          <div className="hours-hour">{formatHour((isCollapsed ? fromHour : 0) + index)}</div>
        </div>
      ))}
    </div>
  )
}

Hours.defaultProps = {
  fromHour: 0,
  isCollapsed: false,
  onClick: noop,
}

Hours.propTypes = {
  fromHour: PropTypes.number,
  isCollapsed: PropTypes.bool,
  onClick: PropTypes.func,
}

export default Hours
